import vv_utils from './vv_utils';
import { fullInvokeMachine, passwordLoginUser, socialLoginUser } from './vv_api';
import validateEmail from './email-validator';
import {redirectRequest} from "./vv_c";
import requestWebAuthn from './vv_webauthn';

/* eslint-disable no-param-reassign */

const loginValidationInit = () => {
  const tenant = window.vv_tenant_data;
  
  const fieldFormMap = {
    "email": "#split-login-email",
    "password": "#split-login-password"
  }

  //TODO find a better way to share this between submit event and the perfom action call
  let submitter = { 'value':'', 'form': {} };

  const alertbox = document.getElementById('split-alert');

  const form = document.getElementById('login-form');

  //InboundAlerts
  let alertText = "";

  function readInboundQueryResult() {
    //Inbound query string codes  
    const urlparams = new URLSearchParams(window.location.search);
    const code = urlparams.get('error');

    //some error with OIDC, display error
    if (code) {
      if (code && vv_utils.messageMap[code]) {
        alertText = vv_utils.messageMap[code];
      } else {
        alertText = "There was an unexpected error adding the social identity";
      }
    }
  }

  function showAndResetInboundQueryAlert() {
    if (alertText) {
      vv_utils.showalert(alertText, "danger", alertbox);
    }
    alertText = "";
  }


  //This had to be done manually instead of using bootstrap because we
  //added a custom 'eye' icon through a container div that did not allow for a
  //feedback div directly under the input tag like normal
  function clearPasswordFeedback() {
    let passwordfeedback = document.getElementById('login-password-feedback');
    //passwordfeedback.classList.remove(':invalid');
    //passwordfeedback.classList.remove(':valid');
    passwordfeedback.style.display = 'none';
  }

  function checkValidity() {
    return new Promise(function(resolve, reject){
      form.classList.remove("was-validated");

      if (submitter.value === 'vv' || submitter.value === 'passwordless') {
        //do nothing
      } else if (submitter.value === 'google' || submitter.value === 'microsoft' || submitter.value === 'microsoftError') {
        return true;
      } else {
        throw new Error('invalid submitter');
      }
      let valid = true;
      let email = document.getElementById('split-login-email');
      let password = document.getElementById('split-login-password');
      let passwordfeedback = document.getElementById('login-password-feedback');

      if (email.value && validateEmail(email.value) && email.value.length <= 320) {
        //do nothing bootstrap handles the clearing
      } else {
        
        vv_utils.makeInvalid(email);
        valid = false;
      }
      
      

      // if(password.value === "" && window.vv_tenant_data.allow_hardware){
      //   submitter.value = 'passwordless';
      // } 

      
      if(password.value !== "" && submitter.value === 'passwordless'){
        passwordfeedback.innerText = "password must be blank to use a passkey";  
        vv_utils.makeInvalid(password);
        passwordfeedback.style.display = 'block';
        valid = false;
      }


      if(submitter.value === 'vv'){
        //a blank password can also be accepted
        if (password.value === "" || password.value.length <= 255) {
          clearPasswordFeedback();
        } else {
          vv_utils.makeInvalid(password);
          passwordfeedback.innerText = "Please enter a valid password";  
          passwordfeedback.style.display = 'block';
          
          valid = false;
        }
      }

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  //TODO figure out a better way to grab the submitter of which form was clicked
  function loginFormSubmit(e, service) {
    if (e.preventDefault) e.preventDefault();
    
    
    
    let currentState = service.getSnapshot().value;
    

    //note safari does not support e.submitter but we use a polyfill
    if (e.submitter) {
      submitter.value = String(e.submitter.value);
      submitter.form.id = String(e.submitter.form.id);
    }
    //hopefully for the safari case we rely on the button click event


    if (currentState && (currentState.toLowerCase() === 'invalid' || currentState.toLowerCase() === 'failed' )){
      return "input";
    }
    return "";    
  }

  /*eslint-disable no-inner-declarations*/
  function doPasswordlessLogin(context, event){
  
    let email = document.getElementById('split-login-email').value;
    if (document.getElementById('split-checkbox').checked) {
      window.localStorage.setItem('login_username', email);
      window.localStorage.setItem('login_method', 'passwordless');
    } else {
      window.localStorage.setItem('login_username', '');
      window.localStorage.setItem('login_method', '');
    }

    const beginReq = {
      'provider': submitter.value,
      'email': email
    }
    return requestWebAuthn(beginReq, "login", alertbox);
  }

  /*eslint-enable no-inner-declarations*/
  function doCredLogin() {
    let password = document.getElementById('split-login-password').value;
    let email = document.getElementById('split-login-email').value;

    if (document.getElementById('split-checkbox').checked) {
      window.localStorage.setItem('login_username', email);
      window.localStorage.setItem('login_method', '');
    } else {
      window.localStorage.setItem('login_username', '');
      window.localStorage.setItem('login_method', '');
    }

    let userstate = {
      'email': email,
      'password': password,
      'provider': submitter.value
    };
    return passwordLoginUser(userstate)
  }

  //TODO figure out a better way to grab the submitter of which form was clicked
  function socialFormSubmit(e) {
    if (e.preventDefault) e.preventDefault();
    //note safari does not support e.submitter but we use a polyfill
    if (e.submitter) {
      submitter.value = String(e.submitter.value);
      submitter.form.id = String(e.submitter.form.id);
    }
    //hopefully for the safari case we rely on the button click event
  }

  function doSocialLogin(servError, service) {
    let userstate = {
      'email': '',
      'password': '',
      'provider': submitter.value
    };
    return socialLoginUser(userstate)
  }

  //Process the Remember check box and set the values if the are in local storage
  function getAndSetRememberUser() {
    let username = window.localStorage.getItem('login_username');
    if (username && validateEmail(username)) {
      
      document.getElementById('split-login-email').value = username;
      document.getElementById('split-checkbox').checked = true;
    }
  }

  function handleLogin (){
    
    
    let password = document.getElementById('split-login-password').value;
    // create an override so that if the submitter is still vv but there is no password then assume
    // the user meant to do passwordless
    let passwordless_override = submitter.value === "vv" && password === "";

    if (submitter.form.id === 'login-form' && submitter.value === "vv" && password !== "") {
      return doCredLogin();
    } else if (submitter.form.id === 'social-form') {
      return doSocialLogin();
    } else if(submitter.form.id === 'login-form' && (submitter.value === "passwordless" || passwordless_override) ){
      return doPasswordlessLogin()
    } else {
      throw new vv_utils.GenericException("invalid submitter");
    }
  }

  const { interpret } = window.XState;

  if (form && form !== null) {
    const validationService = interpret(
      fullInvokeMachine.withConfig({
        actions: {
          loading: () => {
            readInboundQueryResult();
          },            
          loaded: () => {
            getAndSetRememberUser();
            showAndResetInboundQueryAlert();
          },
          message: (context, event) => {
            vv_utils.clearInputValidation(form);
            vv_utils.clearalert(alertbox);
            clearPasswordFeedback();
          },
          validationFailed: () => {
            vv_utils.showalert('There are validation errors, fix fields highlighted in red and submit again.', 'danger', alertbox);
          },
          validationSucceeded: () => {
            validationService.send('PERFORM_ACTION');
          },
          actionFailed: (context, event) => {
            if(context.error.fields){
              const invalidIds = context.error.fields.map((field) => fieldFormMap[field]);
              invalidIds.forEach((id)=>{
                vv_utils.makeInvalid(id);
              })
            }
            
            vv_utils.logError(context.error);
            vv_utils.showStateErrors("There was an unexpected error", context.error , alertbox);
          },
          actionSucceeded: (context, event)=> {
            
            const jsonResponse = window._.pick(context.data , Object.keys(redirectRequest));
            window.location.assign(jsonResponse.redirect);
            validationService.send("LOAD_COMPLETE");
          }
        },
        services: {
          validate_service: (context, event) => checkValidity(context, event),
          //eslint-disable-next-line
          action_service: (context, event) => {return handleLogin(context, event)}
        }
      })
    )
    .onTransition((state) => {})
    .start();

    //eslint-disable-next-line
    vv_utils.addFormAndMachineServiceChangeAndInputHandlers(form, validationService, loginFormSubmit);

    //We only need to attach this submit event manually to enable the social form
    const socialform = document.getElementById('social-form');
    if (socialform) {
      socialform.addEventListener('submit', (event) => {
        socialFormSubmit(event);
        validationService.send('OVERRIDE');
        validationService.send('PERFORM_ACTION');
      });
    }
    
    vv_utils.AttachAndSendFormEventsToMachineService(form, validationService, 'input[type="checkbox"]', 'change');
    vv_utils.AttachAndSendFormEventsToMachineService(form, validationService, 'input[type="radio"]', 'change');
    vv_utils.AttachAndSendFormEventsToMachineService(form, validationService, 'input', 'input');

    // //set an eventhandler for the submit buttons to capture which was clicked
    // let nodeListToAddEvents = document.querySelectorAll('button[vv-trigger="submit"]');
    // if (nodeListToAddEvents && nodeListToAddEvents.length > 0 ) {
    //   Object.values(nodeListToAddEvents).forEach(function(node) {
    //     
    //     node.addEventListener('click', (event) => {
    //       if (node.value && node.closest("form")) {
    //         submitter.value = String(node.value);
    //         submitter.form.id = String(node.closest("form").id);
    //         // if(node.value === "passwordless"){
    //         //   const password = document.getElementById('split-login-password');
    //         //   password.value = "";
    //         //   clearPasswordFeedback();
    //         //   password.classList.remove('is-invalid')          
    //         // }
    //       } else {
    //         submitter.value = 'vv';
    //         submitter.form.id = 'login-form';
    //       }
    //       
    //       
    //       node.closest("form").submit();
    //     })
    //   })
    // }


    const passwordSection = document.getElementById("loginPasswordSection");
    const optionText = document.getElementById("loginOptionText");
    const fidoSection = document.getElementById("fidoSection")
    const passswordLoginBtnSection = document.getElementById("btn-password-login-section");

    if(!window.vv_tenant_data.allow_passwords && !window.vv_tenant_data.allow_hardware){
      optionText.classList.add("d-none");
      fidoSection.classList.add("d-none");
      passwordSection.classList.add("d-none");
      passswordLoginBtnSection.classList.add("d-none");
    }
    
    if(tenant.allow_passwords && !tenant.allow_hardware){
      optionText.classList.add("d-none")
      fidoSection.classList.add("d-none")
    }

    if(!tenant.allow_passwords && tenant.allow_hardware) {
      optionText.classList.add("d-none")
      passwordSection.classList.add("d-none")
      passswordLoginBtnSection.classList.add("d-none")
      fidoSection.classList.add("d-none")
    }

    const socialbuttons = document.getElementById("socialbuttons");
    if (socialbuttons) {
      if (window.vv_tenant_data.allow_social) {
        socialbuttons.classList.remove('d-none');
      } else {
        socialbuttons.parentElement.removeChild(socialbuttons);
      }
    }

    //After the state machince is fully configured, move out of loading
    validationService.send('LOAD_COMPLETE');
  }

};

export default loginValidationInit;

//testing info
//document.querySelector("button[name='microsoft']").value = 'microsoftError';
